<template>
    <div v-if="isMyturn && timeLeft>0 && timeLeft<=5" class="timeOutWarning">
        <span>
            {{timeLeft}}
        </span>
    </div>
</template>

<script>
import store from "@/store";
export default {
    computed:{
        isMyturn: () => store.getters.isMyturn,
        timeLeft: () => store.getters.timeLeft
    }
}
</script>